import axios from 'axios';
import { logAuditTrailEvent } from 'services/system_setup/auditTrail';

const MODULE_CODE = 'cust';

function logCustomersAction(action, description, payload, isSuccess = 1) {
	void logAuditTrailEvent({
		moduleCode: MODULE_CODE,
		subModuleCode: 'customers',
		action,
		description,
		payload,
		isSuccess,
	});
}


export async function fetchCustomers(payload) {


	const customer_code = payload.customer_code === undefined ? '' : payload.customer_code;
	const customer_name = payload.customer_name === undefined ? '' : payload.customer_name;
	const status = payload.status === undefined ? '' : payload.status;

	let customerList = [];

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}customers/search/?customer_code=${customer_code}&customer_name=${customer_name}&status=${status}`,
			data: payload,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		customerList = data;
	} 
	catch(error) {
		logCustomersAction('SEARCH', 'Customer search failed', { request: payload, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	
	logCustomersAction('SEARCH', 'Customer search', { request: payload, resultCount: customerList.length }, 1);
	return customerList;
}

export async function fetchCustomersName() {
	let customersNamelist = [];

	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}customers/names/`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		customersNamelist = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return customersNamelist;
}

/*Add Customer*/
export async function addCustomers(payload) {
	let customerResponse = null;

	try {
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}customers/addcustomer`,
			data: payload,
		}).then(response => {
			return response;
		});

			customerResponse = response;
		} catch (error) {
			logCustomersAction('SAVE', 'Create customer failed', { request: payload, error: error && error.message }, 0);
			throw error;
			// Message.error();
		}

		logCustomersAction('SAVE', 'Create customer', { request: payload }, 1);
		return customerResponse;
}

/*Add Customer Billing Address*/
export async function addCustomerBill(payload) {
	let customerResponse = null;

	try {
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}customers/addCustBill`,
			data: payload,
		}).then(response => {
			return response;
		});

			customerResponse = response;
		} catch (error) {
			logCustomersAction('SAVE', 'Create customer billing details failed', { request: payload, error: error && error.message }, 0);
			throw error;
			// Message.error();
		}

		logCustomersAction('SAVE', 'Create customer billing details', { request: payload }, 1);
		return customerResponse;
}

/*Add Customer Delivery Address*/
export async function addCustomerDel(payload) {
	let customerResponse = null;

	try {
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}customers/addCustDel`,
			data: payload,
		}).then(response => {
			return response;
		});

			customerResponse = response;
		} catch (error) {
			logCustomersAction('SAVE', 'Create customer delivery details failed', { request: payload, error: error && error.message }, 0);
			throw error;
			// Message.error();
		}

		logCustomersAction('SAVE', 'Create customer delivery details', { request: payload }, 1);
		return customerResponse;
}

export async function fetchCustomerCode() {
	let customerCode = [];

	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}customers/getcustomercode/`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		customerCode = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return customerCode;
}

//update customers api
export async function updateCustomers(payload) {
	let customerData = null;
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}customers/update/`,
			data: payload
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		customerData = axiosResponse;
	} 
	catch(error) {
		logCustomersAction('EDIT', 'Update customer failed', { request: payload, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	
	logCustomersAction('EDIT', 'Update customer', { request: payload }, 1);
	return customerData;
}

export async function termsLov() {
	let termslist = [];

	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/termslist/`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		termslist = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return termslist;
}

export async function vatLov() {
	let vatlist = [];

	try {
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lov/vatlist/`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		vatlist = data;
	} catch (error) {
		throw error;
		// Message.error();
	}
	return vatlist;
}

export async function getCustomerBillDetails(customer_id) {
	let details = [];

	try {
		const response = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}customers/customersbillingdetails/`,
			data: customer_id,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		logCustomersAction('VIEW', 'View customer billing details failed', { request: customer_id, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	logCustomersAction('VIEW', 'View customer billing details', { request: customer_id }, 1);
	return details;
}

export async function getCustomerDelDetails(customer_id) {
	let details = [];

	try {
		const response = await axios({
			method: 'POST',
			data: customer_id,
			url: `${process.env.REACT_APP_BACKEND_API}customers/customerdeliverydetails/`,
			headers: {
				'content-type': 'application/json',
			},
		});

		const { data } = response;
		details = data;
	} catch (error) {
		logCustomersAction('VIEW', 'View customer delivery details failed', { request: customer_id, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	logCustomersAction('VIEW', 'View customer delivery details', { request: customer_id }, 1);
	return details;
}

//update customer billing address api
export async function updateCustBillAdd(payload) {
	console.log("🚀 ~ file: customers.jsx ~ line 247 ~ updateCustBillAdd ~ payload", payload)
	let customerData = null;
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}customers/updateCustBillAdd/`,
			data: payload
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		customerData = axiosResponse;
	} 
	catch(error) {
		logCustomersAction('EDIT', 'Update customer billing details failed', { request: payload, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	
	logCustomersAction('EDIT', 'Update customer billing details', { request: payload }, 1);
	return customerData;
}

//update customer delivery address api
export async function updateCustDelAdd(payload) {
    
	let customerData = null;
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}customers/updateCustDelAdd/`,
			data: payload
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		customerData = axiosResponse;
	} 
	catch(error) {
		logCustomersAction('EDIT', 'Update customer delivery details failed', { request: payload, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}
	
	logCustomersAction('EDIT', 'Update customer delivery details', { request: payload }, 1);
	return customerData;
}

//delete billing details
export async function deleteBillDtl(deletedLines) {
	let detail = null;
	
	try{
		const response = await axios({
			method: 'DELETE',
			url: `${process.env.REACT_APP_BACKEND_API}customers/deleteBillingDtl`,
			data: deletedLines,
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		detail = data;
	}
	catch(error) {
		logCustomersAction('DELETE', 'Delete customer billing detail lines failed', { request: deletedLines, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}

	logCustomersAction('DELETE', 'Delete customer billing detail lines', { request: deletedLines }, 1);
	return detail;
}

//delete delivery details
export async function deleteDelDtl(deletedLines) {
	let detail = null;
	
	try{
		const response = await axios({
			method: 'DELETE',
			url: `${process.env.REACT_APP_BACKEND_API}customers/deleteDelDtl`,
			data:  deletedLines,
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		detail = data;
	}
	catch(error) {
		logCustomersAction('DELETE', 'Delete customer delivery detail lines failed', { request: deletedLines, error: error && error.message }, 0);
		throw error;
		// Message.error();
	}

	logCustomersAction('DELETE', 'Delete customer delivery detail lines', { request: deletedLines }, 1);
	return detail;
}
